require('../position/position.css');
module.exports = require('./index-nocss.js');



//////////////////
// WEBPACK FOOTER
// ./~/angular-ui-bootstrap/src/dropdown/index.js
// module id = 458
// module chunks = 1